
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaicabservice() {



    const cardData =
    {
        keyword: 'Mumbai Cab Service',
        heading: 'Vedant Travels: Mumbai Cab Service',
        headingDescription: 'Vedant Travels offers reliable and affordable cab services in Mumbai, ensuring a hassle-free travel experience for business, leisure, and airport transfers. Whether you need a sedan, SUV, or luxury car, our well-maintained fleet caters to all travel needs. Our professional drivers ensure a safe and smooth journey, with flexible pickup and drop-off options. With 24/7 availability, competitive fares, and an easy online booking system, Vedant Travels makes traveling in Mumbai convenient and stress-free.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "The Gateway of India is one of Mumbai’s most iconic landmarks, built in 1924, overlooking the Arabian Sea. This famous historical monument is a top tourist attraction and a must-visit heritage site in Mumbai, known for its Indo-Saracenic architecture and scenic waterfront views."
    },
    {
        "title": "Marine Drive",
        "description": "Marine Drive, also called the Queen’s Necklace, is a picturesque coastal boulevard in Mumbai. This famous sea-facing promenade is perfect for an evening stroll, enjoying the Mumbai skyline, and witnessing breathtaking sunset views over the Arabian Sea."
    },
    {
        "title": "Elephanta Caves",
        "description": "A UNESCO World Heritage Site, Elephanta Caves are a group of ancient rock-cut caves located on Elephanta Island. These historic caves feature stunning sculptures of Lord Shiva dating back to the 5th century, making it one of the best heritage sites near Mumbai."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "Chhatrapati Shivaji Maharaj Terminus (CSMT) is a UNESCO-listed railway station and an architectural marvel in Mumbai. This Victorian Gothic-style heritage structure is one of India’s busiest railway stations and a must-visit historical landmark in Mumbai."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Siddhivinayak Temple is one of the most revered Ganesha temples in Mumbai, attracting thousands of devotees daily. This famous Hindu temple in Mumbai is known for fulfilling wishes and is a significant religious site for spiritual seekers."
    },
    {
        "title": "Juhu Beach",
        "description": "Juhu Beach is one of Mumbai’s most popular beaches, offering a vibrant atmosphere with street food stalls, camel rides, and beautiful sunset views over the Arabian Sea. It is a must-visit tourist spot in Mumbai for relaxation and leisure."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "The Bandra-Worli Sea Link is a modern engineering marvel that connects Bandra and Worli. This cable-stayed bridge offers breathtaking views of the Arabian Sea and the Mumbai skyline, making it a must-see attraction in Mumbai."
    },
    {
        "title": "Colaba Causeway",
        "description": "Colaba Causeway is a shopping paradise in Mumbai, famous for its vibrant street markets, boutiques, and cafés. This lively shopping street near Gateway of India is ideal for buying souvenirs, fashion accessories, and experiencing Mumbai’s cultural vibe."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Haji Ali Dargah is a stunning Indo-Islamic shrine located on an islet in the Arabian Sea. This spiritual landmark in Mumbai is visited by people of all faiths seeking blessings and enjoying its breathtaking coastal views."
    },
    {
        "title": "Film City",
        "description": "Film City is the heart of Bollywood and a must-visit destination for cinema lovers. This massive film studio complex in Mumbai offers guided tours showcasing movie sets, film locations, and behind-the-scenes glimpses into the Indian film industry."
    }
],

"services": [
    {
        "name": "Mumbai Cab Service",
        "description": "Traveling within Mumbai? Book your ride with Vedant Travels for a comfortable and reliable journey. Whether you're heading for a business meeting, leisure, or a family outing, we offer a fleet of well-maintained vehicles to ensure a smooth ride."
    },
    {
        "name": "Mumbai Taxi Service",
        "description": "Looking for a taxi service in Mumbai? Vedant Travels provides dependable and comfortable taxi services across the city. Our fleet includes a variety of vehicles, ensuring we meet your travel needs, whether you're traveling solo or in a group."
    },
    {
        "name": "Mumbai Car Rental",
        "description": "For a hassle-free travel experience in Mumbai, rent a car with Vedant Travels. Choose from a range of vehicles, including compact cars, sedans, and SUVs, to suit your preferences and ensure comfort throughout your journey."
    },
    {
        "name": "Mumbai Cab Booking",
        "description": "Booking a cab in Mumbai is easy with Vedant Travels. Simply book online or call us for a quick and hassle-free booking experience. We offer flexible options to meet your needs, ensuring a smooth ride from start to finish."
    },
    {
        "name": "Mumbai Taxi Booking Online",
        "description": "Make your journey easy by booking a taxi online with Vedant Travels. With just a few clicks, secure your ride and travel comfortably throughout Mumbai. Whether it’s for a short trip or an entire day, our online booking system is quick and efficient."
    },
    {
        "name": "Mumbai to Airport Cab",
        "description": "Need a ride to Mumbai’s airport? Vedant Travels offers reliable and timely cab services to and from the airport. Our professional drivers ensure you arrive on time for your flight, with a comfortable ride to start or end your trip."
    },
    {
        "name": "Best Taxi Service in Mumbai",
        "description": "For the best taxi service in Mumbai, choose Vedant Travels. We offer top-notch vehicles, professional drivers, and reliable services to ensure your journey is comfortable, safe, and on time."
    },
    {
        "name": "Mumbai Local Taxi",
        "description": "Explore the city of Mumbai with Vedant Travels’ local taxi service. Whether you're visiting landmarks, shopping districts, or restaurants, our local taxis offer flexible options for your comfort and convenience while you enjoy the best of Mumbai."
    },
    {
        "name": "Mumbai Car Hire",
        "description": "Looking to hire a car for a day or longer in Mumbai? Vedant Travels offers car hire services with experienced drivers to ensure you have a safe and comfortable experience. Choose from a variety of vehicles based on your preferences and travel plans."
    },
    {
        "name": "Mumbai Taxi Fare",
        "description": "At Vedant Travels, we offer competitive and transparent pricing for all your taxi journeys in Mumbai. Whether it’s a short ride or a longer journey, you can trust us to provide fair fares with no hidden charges."
    },
    {
        "name": "Mumbai City Cab Service",
        "description": "For dependable city cab services in Mumbai, Vedant Travels is your go-to option. We provide efficient, reliable, and comfortable taxi services throughout the city. Whether it’s a quick trip or a day out exploring, our cabs ensure a smooth experience."
    }
],


"tableData": [
    ["Mumbai Cab Service", "Mumbai Taxi Service"],
    ["Mumbai Car Rental", "Mumbai Cab Booking"],
    ["Mumbai Taxi Booking Online", "Mumbai to Airport Cab"],
    ["Best Taxi Service Mumbai", "Mumbai Local Taxi"],
    ["Mumbai Car Hire", "Mumbai Taxi Fare"],
    ["Mumbai City Cab Service", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand that timely service is essential. Whether you're headed to an important meeting, airport, or simply sightseeing, our drivers ensure punctual pickups and drop-offs, making your travel across Mumbai hassle-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Enjoy a comfortable ride in our spacious, well-maintained vehicles. Our cars are designed for your comfort with ample legroom, air conditioning, and premium seating, making every ride in Mumbai a relaxing experience."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly skilled and familiar with Mumbai's busy streets. They ensure a smooth and safe journey, taking you to your destination efficiently and with expert knowledge of the best routes around the city."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We believe in providing excellent value for money. Our pricing is competitive, and there are no hidden charges. With Vedant Travels, you get clear and upfront costs, making your travel affordable and stress-free."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly inspected and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety standards for your peace of mind."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you need a cab in the early hours or a late-night ride, Vedant Travels is available 24/7. Our customer service team is ready to assist you at any time, ensuring that you're always covered."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking a cab with Vedant Travels is easy. You can book online through our website or app, or simply call our customer service team, who are happy to assist with your reservation."
    },
    {
      "WhyChooseheading": "Customized Travel Options",
      "WhyChoosedescription": "Whether you're in Mumbai for business, leisure, or a family trip, we offer customized travel solutions tailored to your needs. Let us know your preferences, and we'll ensure your journey is suited to your requirements."
    }
  ]



    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai cab with Vedant Travels?',
            answer: 'You can book a cab easily via our website or mobile app. Alternatively, our customer service team is available to assist you with your booking over the phone.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced in city travel?',
            answer: 'Yes, our drivers are trained professionals who are well-versed in navigating Mumbai’s busy streets, ensuring a smooth and timely ride to your destination.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai cab services?',
            answer: 'We offer a wide range of vehicles, including sedans, SUVs, and luxury cars, all well-maintained and comfortable for your journey.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai cab rental?',
            answer: 'We accept various payment methods, including cash, credit/debit cards, and online payments through our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip within Mumbai?',
            answer: 'Yes, we offer round-trip options for your convenience. Simply provide the return details during booking, and we will ensure a seamless trip.',
        },
        {
            id: 6,
            question: 'Are there extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be communicated upfront. We pride ourselves on transparency with no hidden fees.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Mumbai?',
            answer: 'Yes, we offer sightseeing services to explore Mumbai’s top attractions such as the Gateway of India, Marine Drive, and more, with a professional driver guiding your tour.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai cab?',
            answer: 'Our vehicles can easily accommodate standard luggage. If you have more luggage or special requirements, feel free to inform us when booking, and we will accommodate your needs.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel in Mumbai?',
            answer: 'Yes, we offer tailored corporate travel services for meetings, conferences, and business events in Mumbai, ensuring a professional and comfortable experience.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai cab services?',
            answer: 'Vedant Travels stands out for its reliable, comfortable, and affordable services. With professional drivers, well-maintained vehicles, and clear pricing, we guarantee your travel in Mumbai is safe, smooth, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sanjay Mehta",
            title: "Business Traveler",
            quote: "I used Vedant Travels for a business trip in Mumbai. The service was outstanding! The driver was punctual and courteous, and the car was clean and comfortable. Highly recommend it!",
            rating: 5,
        },
        {
            name: "Mrs. Neha Gupta",
            title: "Family Traveler",
            quote: "Our family had a great experience with Vedant Travels for sightseeing around Mumbai. The driver was friendly, and the car was perfect for our needs. We will definitely book again.",
            rating: 5,
        },
    ];
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
   
 

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Cab Service",
  "image": "https://vedanttravels.in/assets/images/mumbai-cab-service.jpg",
  "description": "Book reliable and affordable Mumbai cab service with Vedant Travels. Choose from AC sedans, SUVs, and tempo travellers for local rides, airport transfers, and outstation trips across Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-cab-service"
  }
};




    return (
        <div>
              <Helmet>
  <title>Mumbai Cab Service | Reliable & Affordable | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book reliable and affordable Mumbai cab service with Vedant Travels. Choose from AC sedans, SUVs, and tempo travellers for local rides, airport transfers, and outstation trips across Mumbai." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Cab Service, Cab Booking Mumbai, Mumbai Taxi Service, Vedant Travels Mumbai, AC Cab Mumbai, SUV Cab Mumbai, Local Cab Mumbai, Airport Transfer Mumbai, Outstation Cab Mumbai, Affordable Taxi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/77.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaicabservice;